import { IBlock } from "../../../framework/src/IBlock"
import { Message } from "../../../framework/src/Message"
import { BlockComponent } from "../../../framework/src/BlockComponent"
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum"
import { runEngine } from "../../../framework/src/RunEngine"
import { getStorageData } from "framework/src/Utilities"

// Customizable Area Start
export interface IOrder {
  id: string
  orderNumber: string
  orderDate: string
  validTill: string
  subscription: string
  totalAmount: number
  status: string
}
export interface OrdersApiResponse {
  data: {
    id: string
    type: string
    attributes: {
      id: number
      order_number: string
      status: string
      total: number
      gst: number
      sub_total: number
      valid_date: string
      active_plan: boolean
      order_date: string
      auto_renewal: boolean
      subscription: {
        id: number
        name: string
        price: string
      }
      account: {
        id: number
        full_name: string
        email: string
      }
    }
  }[]
}

interface OrdersApiResponseError {
  error: string
}
// Customizable Area End

export const configJSON = require("./config")

export interface Props {
  navigation: any
  id: string
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  orders: IOrder[]
  isLoading: boolean
  // Customizable Area End
}

interface SS {
  id: any
}

export default class MyOrdersController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  getUserOrderApiCallId: string = ""
  // Customizable Area End

  constructor(props: Props) {
    super(props)
    this.receive = this.receive.bind(this)

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ]

    this.state = {
      orders: [],
      isLoading: false,
    }
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages)
  }
  async componentDidMount() {
    super.componentDidMount()
    // Customizable Area Start
    this.getUserOrderDetails()
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      )
      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      )
      if (apiRequestCallId && responseJson) {
        if (apiRequestCallId === this.getUserOrderApiCallId) {
          this.handleGetProfileDetails(responseJson)
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  getUserOrderDetails = async () => {
    this.setState({ isLoading: true })

    const token = await getStorageData(configJSON.TOKEN)
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )
    this.getUserOrderApiCallId = requestMessage.messageId
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ "Content-Type": "application/json", token })
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updatePaymentInfoApiEndpoint
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.listOfOrdersMethod
    )
    runEngine.sendMessage(requestMessage.id, requestMessage)
  }

  handleGetProfileDetails = (
    responseJson: OrdersApiResponse | OrdersApiResponseError
  ) => {
    if ("error" in responseJson) {
      this.setState({ orders: [], isLoading: false })
      return
    }

    const formattedOrders: IOrder[] = responseJson.data.map((item) => {
      const {
        order_number,
        order_date,
        valid_date,
        subscription,
        total,
        status,
      } = item.attributes

      return {
        id: item.id,
        orderNumber: order_number,
        orderDate: order_date,
        validTill: valid_date,
        subscription: subscription.name,
        totalAmount: total,
        status,
      }
    })

    this.setState({ orders: formattedOrders, isLoading: false })
  }
  // Customizable Area End
}
